
//BASE Url
export const BASE_URL : string = 'api/Component'

export class ComponentType {

  Id: number
  TypeId: string
    Title: string
    Order: number;
}

export interface ComponentList {
    ComponentDescription: string;
    ComponentId: string;
    ComponentMake: string;
    ComponentType: string;
    EquipModel: string;
    compartid_auto: string;
    progid: string;
    Pitch:string;
}
export interface CompIDRowData {
    compart: string
    compart_note: string
    compartid: string
    compartid_auto: string
    comparttype_auto: number
    moduleid: string
    progid: number
    moduledesc: string
    modified_user: string
    modified_date_short: string
    Model_Id: string
    Model_Names: string
    make_auto: number
    makedesc: string
    tool_auto: number
    tool_name: string
    budget_life: number
     PropelBudgetLife: number
    track_compart_worn_calc_method_auto: number
    track_compart_worn_calc_method_name: string
    smcs_code: number
    paretCompartID:number
    modelID:any
    userid:string
    DistanceBudget: number
    CaseParTNumber :string;
    BERCOPartNumber :string;
    KTSUPartNumber :string;
    OEMPartNumber :string;
    ITMPartNumber :string;
    ITRPartNumber :string;
    Cost :number;
    QuantityInStock :number;
    PartLineId :number;
}

export class MeasurementToolsViewModel {
    public ToolId: number;
    public ToolCode: string;
    public ToolName: string;
}
export class Make {
    public Id: number;
    public Name: string;
}
export class Model {
    public Id: number;
    public Title: string;
}
export class CompartToolImageViewModel {
    Id: number
    CompartId: number
    ToolId: number
    ToolName: string
    CreatedDate: string
    ImageDataBase64: string
    ImageType: string
}

export class MeasurementImage {
    compartid_auto: string
    Title: string
    ImageDataBase64: string
    ToolId: number
    tool_name: string
    ImageType: string
    Message: string

}

export class LisComponentImageTypeVM {
    compart_attach_auto: string
    compartid_auto: string
    comparttype_auto: string
    compart_attach_type_auto: string
    ComponenetType: string
    ImageType: string
    Attachment: string
    AttachmentPath: string
    AttachmentName: string
    tool_auto: string


}


export class ComponentListType {
  ImageId: number;
    ComponenetType: string
    comparttype_auto: string
    CompartImage: string
    CompartImagePath: string
  ComponenetFamily: string
}
export class ToolDeatails {
    tool_auto: string
    tool_name: string

}

export class GetComponentImageData {
    Component: ComponentListType[] = [];
    ComponentImageList: LisComponentImageTypeVM[] = [];
    ToolDeatails: ToolDeatails[] = []; 

}




export class GetComponentImage {
    compart_attach_auto: number
    compartid_auto: number
    type_auto: number
    inspection_auto: number
    comparttype_auto: number
    tool_auto: number
    position: number
    attachment: string
    imageName: string
    modified_user: string
    attachment_comp: string
    imageName_comp: string
    compartid: string
    compart: string
  isStandard: boolean
}


// Component life models

export class  JobsiteTypeVM{
    ID:number;
    Name:string;
}
export class ComPerVM{
    data:ComponentPerformanceVM[]
    timePeriod:string[]
}
export class ComponentTypeVM{
    comTypeName:string;
    //comTypeAuto:number;

    comTypeAuto:number[];
    comID: string;
    comName:string;
    compart_note:string;
}
 export class ComponentPerformanceVM{

    EquipmentID:number; 
    customerName: string;
    jobSiteName:string;
    brandName:string;
    FamilyName:string;
    modelName:string;
    serialNo:string;
    unitNo:string;
    systypeName :string;
    ComponentType:string;
    componentName:string;
    part:string;
    side:number;
    hoursOnSurface:number; 
    worn:number;
    evalCode:string;
    Cost:number;
    startDate:string;
    normalize100: number;
    normalize120:number;  
    endDate: string; 
    EquUNit:number;

    
 }

 export class filterComponentPerformance
 {
   customerID: number;
    jobsiteID:number;
    brandID:number;
    modelID:number;
    familyID:number;
    //EquipmentId:number; 
    EquipmentId:number[];
    jobsiteTypeID:number[];
    componentID:number[];;
    side:number;
    componentTypeID:number[];
    startDate:string;
    endDate:string;  
    IsCurrentlyFitted:boolean;
 }

 export class CmponentSearchResult{
    public  AvaiblePerformancesList :ComponentPerformanceVM[];
    public  AvaibleSearch :filterComponentPerformance;
    public  GraphData :ComponentPerformanceVM[];

 }

 export class ComponentActionHistroyVM {
    
    public   ActionId :number;
    public  ActionDesc :string;
    public  Budget :number;
    public  CMU :number;
    public  cost :number;
    public  SMU:number;
    public  ActionDate:Date
    public  ResidualHrs :number;
    public  Worn :number;
    public  ActionTypeId :number;
 }
 
 export interface UpdateComponentSproket {
    CasePartNumberSproket: string;
    BercoPartNumberSproket: string;
    Description: string;
    Quantity: number;
    CompartidAuto: string;
    PartLineId?: number;
    Cost: number;
    PartConfiqAuto:number;
}

export interface ServerReturnMessage {
    Id: number;
    Succeed: boolean;
    Message: string;
    ExceptionMessage: string;
    InnerExceptionMessage: string;
}

export class MakeViewModel {
    FamilyId: number;
    Make_auto: number;
    Makeid: string;
    Makedesc: string;
}

export interface ComponentExtraDetailViewModel {
    CaseParTNumber: string;
    BERCOPartNumber: string;
    KTSUPartNumber: string;
    OEMPartNumber: string;
    ITMPartNumber: string;
    ITRPartNumber: string;
    Cost?: number;  // The question mark indicates the property is optional
    QuantityInStock?: number;
    PartLineId?: number;
    ComponentPitch?:number;
  }

  export interface ActionHistoryComponentData {
    EquipmentId: number;
    EqUnitId: number;
    Cost: number;
    Side: number;
    CompartTypeId: number;
    CompartName: string;
    NewCost:number;
    Pos:number;
}
export interface UpdateComponentCost {
    HistoryId: number;
    EqUnitId: number;
    TotalCost: number;
    Cost: number;
    CompartTypeId: number;
  }

  export class EquipmentModel{
    Id:number;
    Title:string;
  }

  export class EquipmentModelNew{
    Id:number;
    Title:string;
  }
